module.exports = __webpack_public_path__ + "static/Place-Asset-WT-4c12fb8345492648e456528afae3979f.png";